module.exports = __webpack_public_path__ + "img/beneficio-2.cf2c73e8.svg";